module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/locales/fr.json
// module id = 1798
// module chunks = 0